import { IsBoolean, ValidateIf, IsArray, ArrayNotEmpty, ValidateNested, IsNotEmpty, IsString, Matches } from 'class-validator';
import { Transform, Type } from 'class-transformer';

class NameserverDto {
  @Transform(({ value }) => (typeof value === 'string' ? value.trim() : value))
  @IsString()
  @IsNotEmpty({ message: 'validation.nameserver_name_must_not_be_empty' })
  @Matches(
    /^(?=.{1,253}$)(?!-)[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,}$/,
    { message: 'validation.nameserver_must_be_a_valid_domain_e_g_ns1_example_com' }
  )
  name: string;
}

export class DnsNameServerDto {
  @IsBoolean()
  isDefault: boolean;

  // Only validate nameservers if isDefault is false
  @ValidateIf(o => o.isDefault === false)
  @IsArray({ message: 'validation.nameservers_must_be_an_array' })
  @ArrayNotEmpty({ message: 'validation.at_least_one_nameserver_is_required_when_isdefault_is_false' })
  @ValidateNested({ each: true })
  @Type(() => NameserverDto)
  nameservers: NameserverDto[];
}
